import { ReactComponent as FacebookIcon } from '@rocco/icons/svg/brand/facebook.svg';
import { ReactComponent as LinkedInIcon } from '@rocco/icons/svg/brand/linkedin.svg';
import { ReactComponent as TwitterIcon } from '@rocco/icons/svg/brand/x-twitter.svg';
import { ReactComponent as EmailIcon } from '@rocco/icons/svg/envelope-filled.svg';
import { LinkIcon } from 'lucide-react';

export const PLATFORMS = [
    'email',
    'linkedin',
    'facebook',
    'twitter',
    'copy',
] as const;

export type Platform = (typeof PLATFORMS)[number];

export const PLATFORMS_CONFIG: {
    platform: Platform;
    icon: React.ReactNode;
    displayName: string;
}[] = [
    {
        platform: 'email',
        icon: <EmailIcon className="w-6 h-6" />,
        displayName: 'Email',
    },
    {
        platform: 'linkedin',
        icon: <LinkedInIcon className="w-6 h-6" />,
        displayName: 'LinkedIn',
    },
    {
        platform: 'facebook',
        icon: <FacebookIcon className="w-6 h-6" />,
        displayName: 'Facebook',
    },
    {
        platform: 'twitter',
        icon: <TwitterIcon className="w-6 h-6" />,
        displayName: 'X (Twitter)',
    },
    {
        platform: 'copy',
        icon: <LinkIcon className="w-6 h-6" />,
        displayName: 'Copy Link',
    },
];

// Get platform info based on platform name
export const getPlatformInfo = (
    platform: Platform,
): { icon: React.ReactNode; displayName: string } => {
    const platformInfo = PLATFORMS_CONFIG.find(p => p.platform === platform);

    if (!platformInfo) {
        console.error(`Platform ${platform} not found`);
        // Ensure we return a valid object that matches the return type
        return {
            icon: <></>,
            displayName: platform,
        };
    }

    return platformInfo;
};
